import { render, staticRenderFns } from "./ForestMapPage.vue?vue&type=template&id=5c8032b4&"
import script from "./ForestMapPage.vue?vue&type=script&lang=ts&"
export * from "./ForestMapPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports